import React  from 'react'
import {NavHeadLinks} from '../../components/modules/pannelli/HeadLink';
import {ItemCell} from '../../components/modules/grids/Item';
import {MenuMobile} from '../../components/modules/pannelli/MenuMobile';
import {useThemes} from '../../components/hooks/hooks-mongoDB/useThemes';
import {useArticles} from '../../components/hooks/hooks-mongoDB/useArticles';
import {useCards} from '../../components/hooks/hooks-mongoDB/useCards'
import Scheda from '../../components/modules/scheda/Scheda';
import typoXS from '../../components/images/tipologia/intestato/TipologiaWd500.png';
import typoS from '../../components/images/tipologia/intestato/TipologiaWd800.png';
import typoM from '../../components/images/tipologia/intestato/TipologiaWd1200.png';
import typoL from '../../components/images/tipologia/intestato/TipologiaWd1600.png';
import typoXL from '../../components/images/tipologia/intestato/TipologiaWd2000.png';
import typoXXL from '../../components/images/tipologia/intestato/TipologiaWd3500.png';
import '../../components/modules/scheda/scheda.scss';
import '../../components/modules/grids/item.scss';

function Tipologia() {
    const {themes} = useThemes();
    // Componente 1 - Carica theme di tipologia
    const tipologia_Theme = themes[8];
    // Componente 2 - Carica articles di tipologia
    const { articles: articles_Grp } = useArticles('tipologia');
    const articles_Tipologia = articles_Grp || [];
    console.log('in tiplogia articles value:', articles_Tipologia);
    // Componente 2 - Carica cards di tipologia
    const { cards: cards_Grp } = useCards('tipologia');
    const cards_Tipologia = cards_Grp || [];
    console.log('in tiplogia cards value:', cards_Tipologia);
    

    return (
        <section>
            
            {tipologia_Theme && <NavHeadLinks title={tipologia_Theme.tema_titolo} picXS={typoXS}  picS={typoS}  picM={typoM} picL={typoL} picXL={typoXL} picXXL={typoXXL}/>}
            <MenuMobile temi={themes}/>
            <Scheda cards={cards_Tipologia}/>
            {tipologia_Theme && <div className="tema__title mb-2"><h1 className ="title__top">{tipologia_Theme.tema_titolo}</h1></div> } 
            <div className="layout__grids">
                <ItemCell item={articles_Tipologia}/>
            </div>
        </section>
    )
}
export default Tipologia;
